import { API_GET_COUPANG_BANNER, API_GET_COUPANG_SEARCH } from "core/api";
import API from "core/networks/API";
import { useEffect, useState } from "react";

export const useGetCoupang = (params: any) => {
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const fetchCoupang = async () => {
    try {
      setLoading(true);
      const resp = await API.get(API_GET_COUPANG_SEARCH, params);
      console.log('resp useGetCoupang', resp);
      
      setData(resp?.data?.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }

  }
  useEffect(() => {
    if (params.keyword !== '') {
      fetchCoupang();
    }
  }, [params.keyword]);

  return {data, loading};

};

export const useGetCoupangBanner = (params: any) => {
  const [data, setData] = useState<any>([]);

  const fetchBanner = async () => {
    const resp = await API.get(API_GET_COUPANG_BANNER, {});
    setData(resp.data.data);
  };

  useEffect(() => {
    fetchBanner();
  }, [params]);

  return {data};
};
